import { createReducer } from 'Helpers/redux'
import {
  GET_PLAYLISTS,
  UPDATE_PLAYLISTS,
  CHANGE_PLAYLIST_GENRES,
  CHECK_PLAYLIST,
  SET_PLAYLIST_GENRES_LIMIT,
  UPDATE_STATE_PLAYLISTS,
  GET_PLAYLISTS_LIST_ADMIN,
  SEARCH_PLAYLISTS,
  SET_IS_NEW_PARAMETER,
  ACTIVATE_PLAYLIST,
  DEACTIVATE_PLAYLIST,
  GET_PLAYLIST_INFO,
  SET_DEACTIVATION_ALERT_READ,
  EDIT_PLAYLISTS_LANGUAGES,
  GET_SPOTIFY_PLAYLIST,
} from 'Redux/actions/playListsActions'

const initialState = {
  playlists: [],
  adminPlaylists: [],
  totalPlaylistsAdminTab: 0,
  foundPlaylists: [],
  newPlaylistToSet: null,
}

const handlers = {
  [GET_PLAYLISTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: payload.Playlists,
  }),
  [SET_PLAYLIST_GENRES_LIMIT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: payload.Playlists,
  }),
  [UPDATE_PLAYLISTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: payload.Playlists,
  }),
  [CHANGE_PLAYLIST_GENRES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: prevState.playlists.map(item =>
      item.id === payload.id ? payload : item
    ),
  }),
  [SET_DEACTIVATION_ALERT_READ.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: prevState.playlists.map(item =>
      item.id !== payload.playlist_id
        ? item
        : { ...item, is_deactivation_new: false }
    ),
  }),
  [CHECK_PLAYLIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: [...prevState.playlists, payload],
  }),
  [UPDATE_STATE_PLAYLISTS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: payload.Playlists,
  }),
  [GET_PLAYLISTS_LIST_ADMIN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    adminPlaylists: payload.playlists,
    totalPlaylistsAdminTab: payload.totalPlaylists,
  }),
  [SEARCH_PLAYLISTS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    foundPlaylists: payload.playlists,
  }),
  [SET_IS_NEW_PARAMETER]: (prevState, { payload }) => ({
    ...prevState,
    adminPlaylists: prevState.adminPlaylists.map(item =>
      item.id !== payload ? item : { ...item, is_new: false }
    ),
    foundPlaylists: prevState.foundPlaylists.map(item =>
      item.id !== payload ? item : { ...item, is_new: false }
    ),
  }),
  [ACTIVATE_PLAYLIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    adminPlaylists: prevState.adminPlaylists.map(item =>
      item.id !== payload.playlist_id ? item : { ...item, status: 'activated' }
    ),
    foundPlaylists: prevState.foundPlaylists.map(item =>
      item.id !== payload.playlist_id ? item : { ...item, status: 'activated' }
    ),
  }),
  [DEACTIVATE_PLAYLIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    adminPlaylists: prevState.adminPlaylists.map(item =>
      item.id !== payload.playlist_id
        ? item
        : {
            ...item,
            status: 'deactivated',
            reviews_amount: payload.reviews_amount,
          }
    ),
    foundPlaylists: prevState.foundPlaylists.map(item =>
      item.id !== payload.playlist_id
        ? item
        : {
            ...item,
            status: 'deactivated',
            reviews_amount: payload.reviews_amount,
          }
    ),
  }),
  [GET_PLAYLIST_INFO.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    adminPlaylists: prevState.adminPlaylists.map(item =>
      item.id !== payload.playlist.id || payload.playlist.status === 'pending'
        ? item
        : { ...item, is_new: false }
    ),
    foundPlaylists: prevState.foundPlaylists.map(item =>
      item.id !== payload.playlist.id || payload.playlist.status === 'pending'
        ? item
        : { ...item, is_new: false }
    ),
  }),

  [EDIT_PLAYLISTS_LANGUAGES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    playlists: prevState.playlists.map(
      item => payload.find(payload_item => payload_item.id === item.id) || item
    ),
  }),

  [GET_SPOTIFY_PLAYLIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    newPlaylistToSet: payload,
  }),
}

export default createReducer(initialState, handlers)
